import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const LiveRunEmptyCustomParamValues = () =>
  <Paragraph>
    <strong>
      <Color variant='theme-color-readonly-field-text'>
        Custom parameter values not set. Default parameter values from the test case will be used if no custom value is set.
      </Color>
    </strong>
  </Paragraph>

export default LiveRunEmptyCustomParamValues
